import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { AuthOrgMember } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { DASHBOARD_ALLOW_ASSUMED_WRITES, DASHBOARD_AUTHORIZATION_HEADER, DASHBOARD_IS_LIVE_HEADER } from '@/config/constants';
type GetOrgMemberRequest = {
  auth: string;
  isLive: boolean;
  isAssumedSessionEditMode: boolean;
};
export const getOrgMemberRequest = async ({
  auth,
  isLive,
  isAssumedSessionEditMode
}: GetOrgMemberRequest) => {
  const headers = {
    [DASHBOARD_AUTHORIZATION_HEADER]: auth,
    [DASHBOARD_IS_LIVE_HEADER]: JSON.stringify(isLive),
    [DASHBOARD_ALLOW_ASSUMED_WRITES]: JSON.stringify(isAssumedSessionEditMode)
  };
  const response = await request<AuthOrgMember>({
    headers,
    method: 'GET',
    url: '/org/member'
  });
  return response.data;
};
export const useGetOrgMember = req => {
  const $ = _c(2);
  let t0;
  if ($[0] !== req) {
    t0 = {
      queryKey: ["org-member", req],
      queryFn: () => getOrgMemberRequest(req)
    };
    $[0] = req;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};